var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    transform: "rotate(45)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C14 21.3726 19.3726 14 28 14C19.3726 14 14 6.62742 14 0C14 6.62742 8.62742 14 0 14C8.62742 14 14 21.3726 14 28Z",
    fill: "url(#paint0_radial_loyalshift)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_loyalshift",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.77876 11.3795) rotate(18.6832) scale(29.8025 238.737)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671246,
    stopColor: "#6BA4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342551,
    stopColor: "#4682B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672076,
    stopColor: "#008080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4ad9fbb0cff637406c9a635f935f0973.svg";
export { ForwardRef as ReactComponent };